function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#222b45",
  d: "M23.359 20.895a1.824 1.824 0 0 0 1.732-1.82 1.832 1.832 0 0 0-.6-1.353l-5.8-5.206 2.037-2.255a1.08 1.08 0 0 0-.077-1.522l-3.927-3.548a1.06 1.06 0 0 0-.777-.277 1.071 1.071 0 0 0-.745.354l-6.585 7.29a1.078 1.078 0 0 0 .077 1.523l3.928 3.548a1.07 1.07 0 0 0 .721.278h.057a1.071 1.071 0 0 0 .745-.354l2.106-2.331 5.8 5.206a1.808 1.808 0 0 0 1.22.472zm-7.589-6.911h-.005v.005l-2.425 2.684-3.77-3.405 6.442-7.132 3.77 3.406zm1.274.357l.854-.946L23.7 18.6a.639.639 0 0 1 .043.9.633.633 0 0 1-.44.209.644.644 0 0 1-.46-.166z",
  transform: "translate(-8.338 -4.912)"
});

function SvgBid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.753,
    height: 15.985,
    viewBox: "0 0 16.753 15.985",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBid);
export default __webpack_public_path__ + "static/media/bid.f18928ff.svg";
export { ForwardRef as ReactComponent };